import { validator } from "./validator";
import { isPresent, blankOrValue } from "./baseUtils";

export { isPresent, blankOrValue };

const filterElement = (profileElements, element) => {
  let home_present = profileElements.some((profile) => profile.kind === element);
  return (
    home_present &&
    profileElements.filter(function (profile) {
      return profile.kind == element;
    })[0]
  );
};
export const generateProfileElementObject = (
  profileElements,
  activeProfileElements,
  defaultAnswer,
  element,
  answer,
  embeddedAnswer = "",
) => {
  let home = filterElement(profileElements, element);
  let response;

  if (home && home.answers[answer] != undefined) {
    if (typeof home.answers[answer] === "object" && embeddedAnswer != "") {
      response =
        home.answers[answer][embeddedAnswer] === undefined
          ? defaultAnswer
          : home.answers[answer][embeddedAnswer];
    } else {
      response = home.answers[answer];
    }
  } else {
    response = defaultAnswer;
  }
  return {
    val: response,
    validationKey: activeProfileElements.includes(answer)
      ? `profile_elements_${element}_${answer}${isPresent(embeddedAnswer) ? `_${embeddedAnswer}` : ""}`
      : "",
  };
};

export const obfuscateString = (str) => {
  if (!str) return "";

  if (str.length <= 4) {
    return str; // Or return '*' repeated str.length times, if you prefer
  }
  const visibleDigits = 4;
  const maskedPart = "*".repeat(str.length - visibleDigits);
  const obfuscatedString = maskedPart + str.slice(-visibleDigits);
  return obfuscatedString;
};

export const setProfileElementsFromState = (
  profileElements,
  defaultAnswer,
  element,
  answer,
  embeddedAnswer = "",
) => {
  let home = filterElement(profileElements, element);
  let response;

  if (home && home.answers[answer] != undefined) {
    if (typeof home.answers[answer] === "object" && embeddedAnswer != "") {
      response =
        home.answers[answer][embeddedAnswer] === undefined
          ? defaultAnswer
          : home.answers[answer][embeddedAnswer];
    } else {
      response = home.answers[answer];
    }
  } else {
    response = defaultAnswer;
  }
  return response;
};

export const formatDate = (date) => {
  if (Date.parse(date)) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  }
};

export const buildProfileForm = (schema, profileElements) => {
  let form = {};
  let key, keyType, defaultAnswer;

  Object.keys(schema).forEach(function (section) {
    form[section] = {};
    Object.keys(schema[section]).forEach(function (sectionItem) {
      keyType = schema[section][sectionItem];
      key = buildProfileKey(schema, section, sectionItem);
      defaultAnswer = keyType == "Array" ? [] : "";
      form[section][key] = setProfileElementsFromState(
        profileElements,
        defaultAnswer,
        section,
        sectionItem,
      );
    });
  });
  return form;
};

export const buildProfileKey = (schema, section, sectionItem) => {
  let keyType = schema[section][sectionItem];
  if (typeof keyType === "object") keyType = "Object";
  return String(sectionItem + "|" + keyType);
};

export const updateProfileField = (form, schema, section, sectionItem, value) => {
  let key = buildProfileKey(schema, section, sectionItem);
  form[section][key] = value;
  return form;
};

export const updateForm = (form, schema, payload) => {
  let value;
  Object.keys(payload).forEach(function (section) {
    Object.keys(payload[section]).forEach(function (sectionItem) {
      value = payload[section][sectionItem];
      form = updateProfileField(form, schema, section, sectionItem, value);
    });
  });
  return form;
};

export const setElementValue = (element, value) => {
  let ev = new Event("input", { bubbles: true });
  ev.simulated = true;
  $(element).val(value);
  element.dispatchEvent(ev);
};

export const setSelectElementValue = (element, value) => {
  let ev = new Event("change", { bubbles: true });
  ev.simulated = true;
  $(element).val(value);
  element.dispatchEvent(ev);
};

export const randomChars = (length) => {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};


export const handleSelection = (original, newSelection) => {
  let newSelectionArray;

  if (original.includes(newSelection)) {
    newSelectionArray = original.filter((s) => s !== newSelection);
  } else {
    newSelectionArray = [...original, newSelection];
  }
  return newSelectionArray;
};

export const generateResidentElementObject = (field, resident, householdVaccination = null) => {
  if (field.includes(".")) {
    const [key1, key2] = field.split(".");

    if (householdVaccination) {
      return {
        val: householdVaccination,
        validationKey: `residents_${field}`,
      };
    }

    return {
      val: resident[key1] ? resident[key1][key2] : "",
      validationKey: `residents_${field}`,
    };
  } else {
    return {
      val: resident[field] || "",
      validationKey: `residents_${field}`,
    };
  }
};

export const generateRoomElementObject = (field, room) => {
  return {
    val: room[field] || "",
    validationKey: `rooms_${field}`,
  };
};

export const changeState = (component, id, val) => {
  const state = component.state.state || component.state;
  const setState = component.setState || component.state.setState;
  const props = component.props || component.state.props;

  component._validationSeq = component._validationSeq || {};
  const currentSeq = (component._validationSeq[id] || 0) + 1;
  component._validationSeq[id] = currentSeq;

  const validationResult = validator(val, state[id].validationKey, props.requiredFields);

  if (validationResult && typeof validationResult.then === 'function') {
    // For async validation, immediately update the input value in state
    if (component.setState) {
      const immediateObj = {
        ...state[id],
        val: val
      };
      component.setState({ [id]: immediateObj });
    } else if (setState) {
      setState(prevState => {
        const immediateObj = {
          ...prevState[id],
          val: val
        };
        return { ...prevState, [id]: immediateObj };
      });
    }

    validationResult.then((valid) => {
      // Discard stale out-of-order async validation responses
      if (component._validationSeq?.[id] !== currentSeq) return;

      if (component.setState) {
        const currentState = component.state.state || component.state;
        const newObj = {
          ...currentState[id],
          val: val,
          valid: valid
        };
        if ("showPopover" in newObj) {
          newObj.showPopover = !valid;
        }
        component.setState({ [id]: newObj });
      } else if (setState) {
        setState(prevState => {
          if (component._validationSeq?.[id] !== currentSeq) return prevState;

          const newObj = {
            ...prevState[id],
            val: val,
            valid: valid
          };
          if ("showPopover" in newObj) {
            newObj.showPopover = !valid;
          }
          return { ...prevState, [id]: newObj };
        });
      }
    });
  } else {
    // For synchronous validation, update value and validation status together
    if (component.setState) {
      const newObj = {
        ...state[id],
        val: val,
        valid: validationResult
      };
      if ("showPopover" in newObj) {
        newObj.showPopover = !validationResult;
      }
      component.setState({ [id]: newObj });
    } else if (setState) {
      setState(prevState => {
        const newObj = {
          ...prevState[id],
          val: val,
          valid: validationResult
        };
        if ("showPopover" in newObj) {
          newObj.showPopover = !validationResult;
        }
        return { ...prevState, [id]: newObj };
      });
    }
  }
};

export const overEighteenYearsAgo = (dateString) => {
  let eighteen_years_ago = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDay(),
  );
  let date = new Date(dateString);
  return date ? date < eighteen_years_ago : false;
};
